import { useEffect } from 'react';
import PropTypes from 'prop-types';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// tenant
import { useTenantConfig } from 'src/context/tenant';

// ----------------------------------------------------------------------

// Blocks access to pages that must not be available on legislative tenants (e.g. the Voter
// Contact Updates report). Redirects legislative users away from the guarded route.
export default function NonLegislativeGuard({ children }) {
  const router = useRouter();
  const { isLegislative } = useTenantConfig();

  useEffect(() => {
    if (isLegislative) {
      router.replace(paths.dashboard.root);
    }
  }, [isLegislative, router]);

  if (isLegislative) {
    return null;
  }

  return <>{children}</>;
}

NonLegislativeGuard.propTypes = {
  children: PropTypes.node,
};
